import Vue from 'vue';
import { beforeRouteEnter } from '@assets/js/routerPageHook.js';
import BannerBtn from '@components/ui-components/banner-btn/component.js';
import formGreen from '@components/base/form-green.vue';
import reviewsItem from '@components/ui-components/reviews-item/component.js';
// import materials from '@components/ui-components/materials/component.js';
import numberService from '@components/ui-components/number-service/component.js';
import titleLink from '@components/ui-components/title-link/component.js';
import caseService from '@components/ui-components/case-service/component.js';
import doubleBlock from '@components/ui-components/double-block/component.js';
import serviceIcons from '@components/ui-components/service-icons/component.js';
import serviceSlider from '@components/ui-components/service-slider/component.js';
import serviceCard from '@components/ui-components/service-card/component.js';
import serviceText from '@components/ui-components/service-text/component.js';
import serviceBlock from '@components/ui-components/service-block/component.js';
import {router} from "@src/routes";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
            vendorOptions: {
                slidesPerView: 5,
                slidesPerColumn: 2,
                spaceBetween: 56,
                speed: 600,
                cursor: "grab",
                navigation: {
                    nextEl: '.js-vendor-next',
                    prevEl: '.js-vendor-prev',
                },
                breakpoints: {
                    2000: {
                        spaceBetween: 40,
                    },
                    1600: {
                        spaceBetween: 32,
                        slidesPerView: 4,
                    },
                    1300: {
                        spaceBetween: 24,
                    },
                    1160: {
                        spaceBetween: 20,
                    },
                    920: {
                        spaceBetween: 16,
                        slidesPerView: 1,
                    }
                }
            },
        }
    },
    components: {
        'banner-btn-cmp': BannerBtn,
        'form-green-cmp': formGreen,
        'reviews-item-cmp': reviewsItem,
        // 'materials-cmp': materials,
        'number-service-cmp': numberService,
        'title-link-cmp': titleLink,
        'case-service-cmp': caseService,
        'double-block-cmp': doubleBlock,
        'service-icons-cmp': serviceIcons,
        'service-slider-cmp': serviceSlider,
        'service-card-cmp': serviceCard,
        'service-text-cmp': serviceText,
        'service-block-cmp': serviceBlock,
    },
    beforeRouteUpdate(to, from, next) {
        const path = to.path.replace(router.history.base, '');
        Vue.http.get(`templates${path}`, { params: to.query }).then(
            (data) => {
                next();
                this.template = data.data;
            },
            () => {
                next('/404');
            }
        );
    },
    beforeRouteEnter,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/services/view/index.js